import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getOutstandingBalance, getSoldCount } from '../selectors';
import { getShop } from '../../../auth/selectors';
import { fetchGiftCardSummary } from '../actions';
import GiftCardStatistics from '../components/GiftCardStatistics';

const GiftCardStatisticsContainer = compose(
  connect(
    state => ({
      soldCount: getSoldCount(state),
      outstandingBalance: getOutstandingBalance(state),
      shopId: getShop(state),
    }),
    { fetchGiftCardSummary },
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchGiftCardSummary(this.props.shopId);
    },
  }),
)(GiftCardStatistics);

export default GiftCardStatisticsContainer;
